var render = function (_h,_vm) {var _c=_vm._c;return _c('SliderQuestion',_vm._g(_vm._b({attrs:{"use-hands":""}},'SliderQuestion',_vm.props,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }